<template>
  <DropdownMenu
    :card-props="cardProps"
    :show-background-blur="true"
    :z-index="zIndex"
  >
    <template #anchor>
      <span
        :class="linkClassName"
      >
        {{ activeListName }}
        <font-awesome-icon
          class="tw-w-5"
          :icon="['far', 'chevron-circle-down']"
        />
      </span>
    </template>
    <template #menu>
      <div class="tw-w-48 lg:tw-w-48">
        <ul>
          <li
            v-for="list in lists"
            :key="list.id"
            class="tw-py-2 tw-px-2.5 tw-border-b-2 border-color"
          >
            <label>
              <RadioButton
                class="tw-mr-2 tw-align-middle"
                v-bind="getInputProps(list)"
                @update:model-value="(checked) => updateSelectedLists(checked, list)"
              />
              {{ list.name }}
            </label>
          </li>
        </ul>
        <div class="tw-py-2 tw-px-2.5 tw-text-xs view-background-color">
          <a
            class="tw-font-bold tw-underline link-color-brand"
            href="https://support.opensnow.com/feature-guides/favorite-lists"
            rel="noopener noreferrer"
            target="_blank"
            @click="handleLearnMoreClick"
          >Learn More</a> about Favorite lists.
        </div>
      </div>
    </template>
  </DropdownMenu>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useUserFavoritesStore } from '@@/stores/UserFavorites';

export default {
  name: 'SelectFavoriteListDropdown',

  props: {
    linkClassName: {
      type: String,
      default: 'tw-text-base',
    },
    zIndex: {
      type: String,
      default: 'tw-z-20',
    },
  },

  computed: {
    ...mapState(useUserFavoritesStore, {
      activeList: 'getActiveList',
      lists: 'getLists',
    }),

    activeListName() {
      return this.activeList.name;
    },

    cardProps() {
      return {
        hasBodyPaddingSmall: false,
        hasBodyShadow: true,
      };
    },
  },

  methods: {
    ...mapActions(useUserFavoritesStore, ['setActiveList']),

    getInputProps(list) {
      return {
        checked: this.activeList.id === list.id,
        name: 'selectedList',
        modelValue: String(list.id),
      };
    },

    /**
     * When the user clicks on the Learn More link then trigger a click on the document body and
     * background blur so the Vue Clickaway directive closes the Dropdown menu.
     */
    handleLearnMoreClick() {
      this.clickToCloseDropdownMenu();
    },

    /**
     * If the list is checked and is not the active list then set it as the active list. Then
     * trigger a click on the document body so the Vue Clickaway directive closes the Dropdown
     * menu.
     */
    updateSelectedLists(checked, list) {
      if (checked && list.id !== this.activeList.id) {
        this.setActiveList(list.id);
      }

      this.clickToCloseDropdownMenu();
    },

    clickToCloseDropdownMenu() {
      document.body.click();

      const backgroundBlur = document.getElementById('dropdownMenuBackgroundBlur');

      if (backgroundBlur) {
        backgroundBlur.click();
      }
    },
  },
};
</script>
